

const bodyOverflow = (()=> {
    const body = document.body;
    body.classList.toggle('overflow');
})

export {bodyOverflow}